import {
    STEP_ID_CONFIRMATION,
    STEP_ID_DETAILS,
    STEP_ID_PAYMENT,
    STEP_ID_TICKETS,
} from '../components/CheckoutStepper/stepLabels';

const ORGANIZER_TRACKING_STEPS = Object.freeze({
    EVENT_PAGE: 'event_page',
    ADD_TO_CART: 'add_to_cart',
    FILL_INFO: 'fill_info',
    INITIATE_CHECKOUT: 'initiate_checkout',
    PURCHASE: 'purchase',
});

const FACEBOOK_PIXEL_PAGE_VIEW_EVENT = 'PageView';
const FACEBOOK_PIXEL_PURCHASE_EVENT = 'Purchase';

const FACEBOOK_PIXEL_EVENT_BY_STEP = Object.freeze({
    [ORGANIZER_TRACKING_STEPS.EVENT_PAGE]: 'ViewContent',
    [ORGANIZER_TRACKING_STEPS.ADD_TO_CART]: 'AddToCart',
    [ORGANIZER_TRACKING_STEPS.FILL_INFO]: null,
    [ORGANIZER_TRACKING_STEPS.INITIATE_CHECKOUT]: 'InitiateCheckout',
    [ORGANIZER_TRACKING_STEPS.PURCHASE]: FACEBOOK_PIXEL_PURCHASE_EVENT,
});

const GOOGLE_ADWORDS_LABEL_KEY_BY_STEP = Object.freeze({
    [ORGANIZER_TRACKING_STEPS.EVENT_PAGE]: 'event_page_label',
    [ORGANIZER_TRACKING_STEPS.ADD_TO_CART]: 'add_to_cart_label',
    [ORGANIZER_TRACKING_STEPS.FILL_INFO]: 'fill_info_label',
    [ORGANIZER_TRACKING_STEPS.INITIATE_CHECKOUT]: 'initiate_checkout_label',
    [ORGANIZER_TRACKING_STEPS.PURCHASE]: 'purchased_label',
});

const ORGANIZER_TRACKING_STEP_BY_CHECKOUT_STEP_ID = Object.freeze({
    [STEP_ID_TICKETS]: ORGANIZER_TRACKING_STEPS.ADD_TO_CART,
    [STEP_ID_DETAILS]: ORGANIZER_TRACKING_STEPS.FILL_INFO,
    [STEP_ID_PAYMENT]: ORGANIZER_TRACKING_STEPS.INITIATE_CHECKOUT,
    [STEP_ID_CONFIRMATION]: ORGANIZER_TRACKING_STEPS.PURCHASE,
});

const CHECKOUT_FUNNEL_TRACKING_STEPS = Object.freeze(
    Object.values(ORGANIZER_TRACKING_STEP_BY_CHECKOUT_STEP_ID)
        .filter(step => step !== ORGANIZER_TRACKING_STEPS.PURCHASE),
);

function getOrganizerTrackingStepForCheckoutStepId(stepId) {
    return ORGANIZER_TRACKING_STEP_BY_CHECKOUT_STEP_ID[stepId] ?? null;
}

function buildOrganizerTrackingContextKeyPrefix(step) {
    return `${step}:`;
}

function buildOrganizerTrackingContextKey(step, subject) {
    return `${buildOrganizerTrackingContextKeyPrefix(step)}${subject}`;
}

export {
    ORGANIZER_TRACKING_STEPS,
    CHECKOUT_FUNNEL_TRACKING_STEPS,
    FACEBOOK_PIXEL_PAGE_VIEW_EVENT,
    FACEBOOK_PIXEL_PURCHASE_EVENT,
    FACEBOOK_PIXEL_EVENT_BY_STEP,
    GOOGLE_ADWORDS_LABEL_KEY_BY_STEP,
    getOrganizerTrackingStepForCheckoutStepId,
    buildOrganizerTrackingContextKey,
    buildOrganizerTrackingContextKeyPrefix,
};
